/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespBuyerAssuranceBox_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly " $refType": "PdpRespBuyerAssuranceBox_user";
};
export type PdpRespBuyerAssuranceBox_user$data = PdpRespBuyerAssuranceBox_user;
export type PdpRespBuyerAssuranceBox_user$key = {
    readonly " $data"?: PdpRespBuyerAssuranceBox_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespBuyerAssuranceBox_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespBuyerAssuranceBox_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '5442a9fcd76f6f65e644d9f0d377c9f9';
export default node;
